import React from 'react';
import { BoxIcon } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string;
  icon: BoxIcon;
  color: 'amber' | 'emerald' | 'red' | 'blue';
}
export function StatCard({
  title,
  value,
  icon: Icon,
  color
}: StatCardProps) {
  const colorMap = {
    amber: 'text-amber-500 bg-amber-500/10',
    emerald: 'text-emerald-500 bg-emerald-500/10',
    red: 'text-red-500 bg-red-500/10',
    blue: 'text-blue-500 bg-blue-500/10'
  };
  return <div className="bg-stone-800 rounded-2xl p-4 flex items-center gap-4 shadow-lg shadow-black/5 border border-stone-700/50 active:scale-[0.98] transition-transform" data-id="element-65">
      <div className={`p-3 rounded-xl ${colorMap[color]}`} data-id="element-66">
        <Icon size={24} data-id="element-67" />
      </div>
      <div data-id="element-68">
        <p className="text-stone-400 text-xs font-medium uppercase tracking-wide" data-id="element-69">
          {title}
        </p>
        <p className="text-stone-50 text-xl font-bold" data-id="element-70">{value}</p>
      </div>
    </div>;
}